import {
  ContentLibraryCategoriesDto,
  ContentLibraryContentDto,
} from '@asset-metrix/portal-gateway-client-js';
import { QueryFunction } from '@tanstack/react-query';

import { extractErrorMessage } from '../../utils/errorMessage';
import {
  QueryKeyWithRole,
  unwrapQueryKeyWithRole,
} from '../../utils/prependRoleId';
import { HttpError } from '../errors';
import { portalGatewayClient } from '../portalGatewayClient';

export type ContentLibraryCategoriesQueryKey = readonly [];

export type ContentLibraryContentsQueryKey = readonly [string[]];

export const fetchContentLibraryCategories: QueryFunction<
  ContentLibraryCategoriesDto,
  QueryKeyWithRole<ContentLibraryCategoriesQueryKey>
> = async () => {
  const response =
    await portalGatewayClient.contentLibrary.getContentLibraryCategories();

  if (!response.ok) {
    throw new HttpError(
      extractErrorMessage(
        response.error,
        'Error fetching content library categories.'
      ),
      response
    );
  }

  return response.data.data;
};

export const fetchContentLibraryContents: QueryFunction<
  ContentLibraryContentDto[],
  QueryKeyWithRole<ContentLibraryContentsQueryKey>
> = async ({ queryKey }) => {
  const [tags] = unwrapQueryKeyWithRole(queryKey).params;

  const response =
    await portalGatewayClient.contentLibrary.searchContentLibraryContents({
      tags,
    });

  if (!response.ok) {
    throw new HttpError(
      extractErrorMessage(
        response.error,
        'Error searching content library contents.'
      ),
      response
    );
  }

  return response.data.data;
};
